const toSafeDate = (value, fallback) => {
  if (value) {
    const date = value instanceof Date ? new Date(value) : new Date(value);
    if (!Number.isNaN(date.getTime())) {
      return date;
    }
  }
  if (fallback) {
    const fallbackDate =
      fallback instanceof Date ? new Date(fallback) : new Date(fallback);
    if (!Number.isNaN(fallbackDate.getTime())) {
      return fallbackDate;
    }
  }
  return new Date();
};

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const extractIterationNumber = (name) => {
  if (typeof name !== "string") return null;
  const match = name.match(/(\d+)/);
  return match ? match[1] : null;
};

export const buildDefaultSprintPayload = (iteration = {}) => {
  const iterationStart = toSafeDate(iteration.start_date, new Date());
  const sprints = Array.isArray(iteration.sprints)
    ? iteration.sprints.filter(Boolean)
    : [];

  let latestEnd = null;
  sprints.forEach((sprint) => {
    const sprintStart = toSafeDate(sprint.start_date, iterationStart);
    const sprintEnd = toSafeDate(sprint.end_date, sprintStart);
    if (!latestEnd || sprintEnd.getTime() > latestEnd.getTime()) {
      latestEnd = sprintEnd;
    }
  });

  let tentativeStart = new Date(iterationStart);
  if (latestEnd) {
    tentativeStart = new Date(latestEnd);
    tentativeStart.setDate(tentativeStart.getDate() + 1);
  }

  const dayOfWeek = tentativeStart.getDay();
  const offsetToMonday = (8 - dayOfWeek) % 7;
  const sprintStart = new Date(tentativeStart);
  sprintStart.setDate(sprintStart.getDate() + offsetToMonday);

  const sprintEnd = new Date(sprintStart);
  sprintEnd.setDate(sprintEnd.getDate() + 20); // 3 weeks ending on Sunday

  const startStr = formatDate(sprintStart);
  const endStr = formatDate(sprintEnd);

  const sprintIndex = sprints.length + 1;
  const iterationNumber =
    extractIterationNumber(iteration.name) ??
    iteration.sequence_number ??
    iteration.index ??
    iteration.id;

  const description =
    iterationNumber !== undefined && iterationNumber !== null
      ? `Sprint ${iterationNumber}.${sprintIndex}`
      : `Sprint ${sprintIndex}`;

  return {
    start_date: startStr,
    end_date: endStr,
    description,
  };
};

export default buildDefaultSprintPayload;
